import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-8cacad0a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex" };
var _hoisted_2 = { style: { "width": "40%" } };
var _hoisted_3 = { style: { "width": "60%" } };
var _hoisted_4 = { class: "unpositioned-teams" };
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
    key: 0,
    class: "hidden-teams-warning"
};
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import TeamMarker from '../../generic/team/TeamMarker.vue';
import PiloteModal from '../../generic/modal/PiloteModal.vue';
import TeamMarkerInfowWindow from './infoWindows/TeamMarkerInfoWindow.vue';
var MAXIMUM_UNPOSITIONED_TEAMS_SHOWN = 20;
export default /*#__PURE__*/ _defineComponent({
    __name: 'UnpositionedTeamsList',
    props: {
        unpositionedTeams: {
            type: Array,
            default: function () { return []; },
        },
    },
    setup: function (__props) {
        var props = __props;
        var t = useI18n({ useScope: 'global' }).t;
        var hiddenUnpositionedTeamsCount = computed(function () {
            var teamsAreHidden = props.unpositionedTeams.length > MAXIMUM_UNPOSITIONED_TEAMS_SHOWN;
            return teamsAreHidden ? props.unpositionedTeams.length - MAXIMUM_UNPOSITIONED_TEAMS_SHOWN : 0;
        });
        var hiddenUnpositionedTeamsWarning = computed(function () {
            var messageKey = hiddenUnpositionedTeamsCount.value === 1 ?
                'assignment.map.unpositionedTeams.hiddenTeam' :
                'assignment.map.unpositionedTeams.hiddenTeams';
            return "".concat(hiddenUnpositionedTeamsCount.value, " ").concat(t(messageKey));
        });
        var unpositionedTeamInfoModalId = ref(null);
        var openUnpositionedTeamInfoModal = function (teamId) {
            unpositionedTeamInfoModalId.value = teamId;
        };
        var closeUnpositionedTeamInfoModal = function () {
            unpositionedTeamInfoModalId.value = null;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("b", _hoisted_2, _toDisplayString(_unref(t)("assignment.map.unpositionedTeams.title")), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.unpositionedTeams.slice(0, MAXIMUM_UNPOSITIONED_TEAMS_SHOWN), function (team) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: team.id,
                                class: "scaled-down-marker",
                                onClick: function ($event) { return (openUnpositionedTeamInfoModal(team.id)); }
                            }, [
                                _createVNode(TeamMarker, { team: team }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(PiloteModal, {
                                            show: unpositionedTeamInfoModalId.value === team.id,
                                            close: closeUnpositionedTeamInfoModal
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(TeamMarkerInfowWindow, { team: team }, null, 8 /* PROPS */, ["team"])
                                            ]; }),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])
                                    ]; }),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["team"])
                            ], 8 /* PROPS */, _hoisted_5));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (hiddenUnpositionedTeamsCount.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " (+" + _toDisplayString(hiddenUnpositionedTeamsWarning.value) + ") ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
